import React, { useState, useEffect } from "react";
import Header from "../Common/Navbar";
import { Link } from "react-router-dom";
import { fetchApi } from "../utlis/axios";
import { useSelector } from "react-redux";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import Loader from "../animation/Loader.json";
import { AuthWrapper } from "../AuthWrapper";
import { FaSearch } from "react-icons/fa";
import { FamilyRegistration } from "../RegistrationForms/FamilyRegistration";
import Pagination from "./Pagination";

export const FamilyListingpage = () => {
  const [familyData, setFamilyData] = useState([]);
  const { access } = useSelector((state) => state.authSlice.userInfo);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedToggle, setSelectedToggle] = useState("in-review");
  const [isLoading, setIsLoading] = useState(null);
  const [registerFamilyPopupOpen, setRegisterFamilyPopup] = useState(false);

  const navigate = useNavigate();

  const getFamilyData = async () => {
    setIsLoading(true);
    try {
      const result = await fetchApi.get(
        `family/?search=${searchQuery}&status=${selectedToggle}`,
        {
          headers: {
            Authorization: `Bearer ${access}`,
          },
        }
      );
      if (result.status === 200) {
        setFamilyData(result?.data);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log({ error });
    }
  };

  useEffect(() => {
    getFamilyData();
  }, [searchQuery, access, selectedToggle]);

  const handleTableRowClick = (id) => {
    navigate(`/familylistingdetail/${id}`);
  };

  const itemsPerPage = 10;
  const totalPages = Math.ceil(familyData.count / itemsPerPage);

  const fetchDataForPage = async (pageNumber) => {
    const newOffset = (pageNumber - 1) * itemsPerPage;

    try {
      const result = await fetchApi.get(
        `family/?limit=${itemsPerPage}&offset=${newOffset}&page=${pageNumber}&pageSize=${itemsPerPage}&search=${searchQuery}&status=${selectedToggle}`,
        {
          headers: {
            Authorization: `Bearer ${access}`,
          },
        }
      );
      return result;
    } catch (error) {
      throw error;
    }
  };

  const handlePageClick = (pageNumber) => {
    if (pageNumber !== currentPage) {
      setCurrentPage(pageNumber);
      setIsLoading(true);

      fetchDataForPage(pageNumber)
        .then((result) => {
          if (result.status === 200) {
            setFamilyData(result?.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const handleToggleClick = (toggleName) => {
    setSelectedToggle(toggleName);
  };

  

  return (
    <AuthWrapper>
      <>
        <Header parent={"family"} />

        <div className="w-full px-[16px] md:px-10 min-h-screen md:mt-32 mt-28 max-w-screen-xl mx-auto">
          {/* Top Section */}
          <div className="flex items-center justify-between gap-3 mt-6 md:mb-8 mb-3">
            {/* Search */}
            <div className="relative flex justify-center border rounded-full sm:py-2 py-[4px] px-2 sm:w-[400px] w-full bg-[#FCFBF7] items-center gap-2">
              <FaSearch className="text-gray-500" />
              <input
                type="search"
                name="search"
                className="w-full outline-none text-gray-600 py-1 px-1 bg-transparent"
                placeholder="Search here...."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>

            <div className="flex items-center gap-4">
              {/* Toggles */}
              <div className="lg:flex hidden gap-2 sm:gap-4 justify-center bg-[#FCFBF7] border border-gray-400 px-[2px] py-[2px] mb-0 rounded-full">
                {["in-review", "accepted", "hold", "rejected"].map((key) => (
                  <span
                    key={key}
                    onClick={() => handleToggleClick(key)}
                    className={`px-2 py-2 text-sm sm:text-base font-medium cursor-pointer ${
                      selectedToggle === key
                        ? "bg-primary-green rounded-full px-4 text-white"
                        : " text-gray-700 hover:bg-gray-100 bg-transparent border-none"
                    }`}
                  >
                    {key === "in-review"
                      ? "Review"
                      : key.charAt(0).toUpperCase() + key.slice(1)}
                  </span>
                ))}
              </div>

              {/* Register Family */}
              <span
                className="sm:text-base text-sm font-medium primary-button"
                onClick={() => setRegisterFamilyPopup(true)}
              >
                Register Family
              </span>
            </div>
          </div>
          {/* Toggles */}
          <div className="flex gap-2 lg:hidden sm:gap-4 mb-6 w-full justify-between bg-[#FCFBF7] border border-gray-400 px-[2px] py-[2px] rounded-full">
            {["in-review", "accepted", "hold", "rejected"].map((key) => (
              <span
                key={key}
                onClick={() => handleToggleClick(key)}
                className={`px-1.5 py-2 text-xs sm:text-base font-medium cursor-pointer ${
                  selectedToggle === key
                    ? "bg-primary-green rounded-full px-4 text-white"
                    : " text-gray-700 hover:bg-gray-100 bg-transparent border-none"
                }`}
              >
                {key === "in-review"
                  ? "Review"
                  : key.charAt(0).toUpperCase() + key.slice(1)}
              </span>
            ))}
          </div>

          {/* Table Section */}
          <div className="overflow-x-auto bg-white rounded-[20px] border border-gray-border">
            <table className="min-w-full border-collapse">
              <thead>
                <tr className="bg-primary-green text-white text-left">
                  <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap ">
                    Name
                  </th>
                  <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                    Priority
                  </th>
                  <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                    Family Members
                  </th>
                  <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                    No. of Sons
                  </th>
                  <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                    No. of Daughters
                  </th>
                  <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                    Registered Date
                  </th>
                  <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                    Status Statement
                  </th>
                </tr>
              </thead>

              <tbody className="">
                {isLoading ? (
                  <tr>
                    <td colSpan={7} className="h-[60vh]">
                      <div className="flex justify-center items-center h-full w-full">
                        <Lottie
                          loop={true}
                          animationData={Loader}
                          style={{ width: "200px" }}
                          className="auth-sidebar-video"
                        />
                      </div>
                    </td>
                  </tr>
                ) : familyData?.results?.length > 0 ? (
                  familyData?.results?.map((data, index) => (
                    <tr
                      key={index}
                      className={`cursor-pointer ${
                        index % 2 === 0 ? "bg-white" : "bg-[#219D8014]"
                      } hover:bg-gray-200`}
                      onClick={() => handleTableRowClick(data?.id)}
                    >
                      <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                        {data?.name}
                      </td>
                      <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate capitalize">
                        {data?.application_priority}
                      </td>
                      <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                        {data?.family_members}
                      </td>
                      <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                        {data?.number_of_sons ?? "0"}
                      </td>
                      <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                        {data?.number_of_daughters ?? "0"}
                      </td>
                      <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                        {moment
                          .utc(data?.updated_at?.toString())
                          .format("MM/DD/YYYY")}
                      </td>
                      <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                        {data?.status_statement &&
                        data.status_statement.length > 30
                          ? `${data.status_statement.slice(0, 30)}...`
                          : data?.status_statement}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className="p-4 text-center">
                      No items found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="flex justify-center items-center mt-6">
            <Pagination
              currentPage={currentPage}
              handlePageClick={handlePageClick}
              totalPages={totalPages}
            />
          </div>
        </div>
      </>

      {registerFamilyPopupOpen && (
        <FamilyRegistration setShowModal={setRegisterFamilyPopup} />
      )}
    </AuthWrapper>
  );
};
